export default __webpack_public_path__ + "static/media/IMG_5247.c6bee611.JPG";